<script>
	import { Route, Router } from "svelte-routing";
	import Jobs from "./Jobs/Jobs.svelte";
	import JobDetail from "./JobDetail/JobDetail.svelte";
	import NotFound from "../../views/NotFound.svelte";
	import { userRole } from "../../store/store";
	import CreateBacklogTask from "./JobsBacklog/CreateBacklogTask.svelte";
	import Assign from "./Assign/Assign.svelte";
</script>

<Router url="/">
	{#if $userRole.includes(1)}
		<Route path="/" component={Jobs} />
		<Route path="/details/:id" let:params>
			<JobDetail jobId={params.id} />
		</Route>
		<Route path="/create-task" component={CreateBacklogTask} />
		<Route path="/assign" component={Assign} />
	{:else}
		<Route path="/*" component={NotFound} />
	{/if}
</Router>
